/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continue_With_OktaInputs */

const en_auth_continue_with_okta = /** @type {(inputs: Auth_Continue_With_OktaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with OKTA`)
};

/**
* | output |
* | --- |
* | "Continue with OKTA" |
*
* @param {Auth_Continue_With_OktaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_continue_with_okta = /** @type {((inputs?: Auth_Continue_With_OktaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continue_With_OktaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_continue_with_okta(inputs)
});